import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})
export class OhcService {
  static storeId = 'cf-store-id';

  constructor(
    private keycloak: Keycloak,
    private httpClient: HttpClient,
  ) { }

  logout() {
    // localStorage.removeItem(OhcService.storeId);
    this.keycloak.logout();
  }

  setStoreId(id: number) {
    localStorage.setItem(OhcService.storeId, JSON.stringify(id));
  }

  /** Сбрасывает сохранённую точку — нужен, когда она больше не принадлежит пользователю. */
  clearStoreId() {
    localStorage.removeItem(OhcService.storeId);
  }

  getStoreId(): number {
    return JSON.parse(localStorage.getItem(OhcService.storeId));
  }

  sendCode(code: string): Observable<any> {
    return this.httpClient.get(`/api/vn/cf/ohc`, {params: new HttpParams().set('code', code)});
  }
}
